module.exports = __webpack_public_path__ + "img/connect_step3.d400bae7.png";